import React from "react";
import { Button } from "@mui/material";

export default function BlueDisableButton({ startIcon, buttonTitle, onClick ,width, disabled, height,endIcon, minWidth}) {
  return (
    <Button
      variant="contained"
      disabled={disabled}
      startIcon={startIcon ? startIcon : ""}
      endIcon={endIcon}
      onClick={onClick}
      sx={{
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: 700,
        textTransform: "none",
        backgroundColor: "#572575",
        width: width?width :null ,
        minWidth:minWidth?minWidth :null,
        height :height ?height :null,
        
        height:32,
        opacity:'30%',
        "&:hover": {
          backgroundColor: "#572575",
        },
      }}
    >
      {buttonTitle}
    </Button>
  );
}
